<script setup>
defineProps({
  percentage: {
    type: Number,
    required: true,
  },
});
</script>

<template>
  <div class="progress-bar-container">
    <div class="progress-bar-background">
      <div class="progress-bar-fill" :style="{ width: percentage + '%' }"></div>
    </div>
  </div>
</template>

<style scoped>
.progress-bar-container {
  position: relative;
  left: 0;
  top: 0;
  right: 0;
  margin-bottom: 1rem;
}

.progress-bar-background {
  width: 100%;
  height: 6px;
  background-color: #c7c7c7;
  overflow: hidden;
  position: relative;
}

.dark .progress-bar-background {
  background-color: #01072b;
}

.progress-bar-fill {
  height: 100%;
  background-color: #f43098;
  transition: width 0.3s ease-in-out;
}

.dark .progress-bar-fill {
  height: 100%;
  background-color: #ffc107;
  transition: width 0.3s ease-in-out;
}
</style>
